import React, {useState} from 'react';
import './App.css';
import Welcome from './pages/welcome'
import ApplicationBar from "./components/ApplicationBar";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import EAD from "./pages/EAD";
import {Container} from "@mui/material";
import END from "./pages/END";
import MOD from "./pages/MOD";
import About from "./pages/About";
import BestMix from "./pages/BestMix";
import Heliair from "./pages/Heliair";
import Footer from "./components/Footer";
import Nitrox from "./pages/Nitrox";
import Trimix from "./pages/Trimix";

function App() {
    const [isVisible, setIsVisible] = useState(true);

    return (
        <div className="App">
            <ApplicationBar isBackButtonVisible={isVisible} />
            <Container sx={{mt: 10, mb: 2}} maxWidth='sm'>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Welcome isBackButtonVisible={isVisible} showBackButton={setIsVisible}/>}/>
                        <Route path="nitrox" element={<Nitrox/>}/>
                        <Route path="trimix" element={<Trimix/>}/>
                        <Route path="heliair" element={<Heliair/>}/>
                        <Route path="best-mix" element={<BestMix/>}/>
                        <Route path="mod" element={<MOD/>}/>
                        <Route path="ead" element={<EAD/>}/>
                        <Route path="end" element={<END/>}/>
                        <Route path="about" element={<About/>}/>
                    </Routes>
                </BrowserRouter>
            </Container>
            <Footer />
        </div>
    );
}

export default App;
